import React, {useEffect, useState} from "react";
import { connect } from 'react-redux';
import * as Yup from "yup";
import * as groupActions from './store/groupActions';
import * as userActions from '../../sc-productComponents/Storage/store/storageActions';
import {hasPermission, parseURL} from "../../sc-utilities";
import GroupForm from "./GroupForm";
import History from "../../../History";
import {Dialog, withStyles} from "@material-ui/core";
import AppLogoLoading from "../../sc-logo";
import { checkIfLoading } from "../../sc-users/User";

const styles = (theme) => ({
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
});

const GroupDetails = props => {
    const { classes, activeCustomerID, translations, permissions, createGroup, editGroup, fetchGroups, fetchUsers, fetchGroup, onEditGroupLicenses, activeCustomerGroupLicensingSetting } = props;
    const [group, setGroup] = useState(null);
    const [loading, setLoading] = useState({users: false, groups: false, group: false});
    const [usersAndGroups, setUsersAndGroups] = useState({users: [], groups: []});

    const searchParams = parseURL(window.location.href);
    const isEdit = window.location.href.includes("edit");

    const getGroup = async () => {
        setLoading(prevState => {return {...prevState, group: true}});
        const result = await fetchGroup({GroupID: searchParams?.GroupID, ActiveCustomerID: activeCustomerID});
        if (result) {
            setGroup(result);
        }
        setLoading(prevState => {return {...prevState, group: false}});
    }

    useEffect(() => {
        const getUsersAndGroups = async () => {
            setLoading(prevState => {return {...prevState, groups: true, users: true}});
            const params = {ActiveCustomerID: activeCustomerID, forEdit: isEdit};
            if (isEdit) {
                params["GroupID"] = searchParams?.GroupID;
            }
            const groupsResult = await fetchGroups(params);
            const usersResult = await fetchUsers({ActiveCustomerID: activeCustomerID, listWithoutGroup: true});
            if (groupsResult && usersResult) {
                setUsersAndGroups({users: usersResult, groups: groupsResult.data});
            }
            setLoading(prevState => {return {...prevState, groups: false, users: false}});
        }
        if (isEdit) {
            getGroup();
        }
        getUsersAndGroups();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleCreate = async data => {
        const requestData = { ...data };
        requestData["ParentID"] = requestData["Parent"].GroupID?? null;
        delete requestData["Parent"];

        requestData["UserIDs"] = requestData["Users"].map((user) => user.value);
        delete requestData["Users"];
        delete requestData["GroupLicensingEnabled"];
        delete requestData["Balances"];
        const result = await createGroup({...requestData, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    const handleEdit = async data => {
        const requestData = { ...data };
        requestData["ParentID"] = requestData["Parent"].GroupID?? null;
        delete requestData["Parent"];

        requestData["UserIDs"] = requestData["Users"].map((user) => user.value);
        delete requestData["Users"];
        delete requestData["GroupLicensingEnabled"];
        delete requestData["Balances"];
        const result = await editGroup({...requestData, GroupID: group?.GroupID, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    const hasAccessAllGroupsPermission = hasPermission(permissions, 'access_all_groups');

    const initialValues = {
        Name: group?.Name,
        Parent: hasAccessAllGroupsPermission? usersAndGroups.groups?.find((g) => g.GroupID===group?.ParentID) || {GroupID: null, Name: translations['none'] || "None"} : usersAndGroups.groups?.find((g) => g.GroupID===group?.ParentID),
        Users: group?.UserGroups?.map((user) => { return { value: user.UserID, displayValue: user.User?.Username } }) || [],
        GroupLicensingEnabled: group?.GroupLicensingEnabled || false,
        Balances: group?.Balances || []
    }

    const formSettings = {
        Validation: {
            Name: Yup.string().required('Required'),
            Parent: Yup.string().required('Required'),
            Users: Yup.array().nullable(),
            GroupLicensingEnabled: Yup.boolean(),
            Balances: Yup.object().nullable()
        },
        FormTitle: isEdit? translations['edit_group'] || 'Edit group' : translations['create_group'] || 'Create group',
        ButtonSubmit: hasPermission(permissions, isEdit? 'group_update' : 'group_create') && {
            Title: translations['save'] || 'SAVE',
            Color: 'primary'
        },
    };

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{classes: {root: classes.loadingScreen}}}>
        <AppLogoLoading />
    </Dialog>

    return <>
        {checkIfLoading(loading)? loadingScreen : <GroupForm
            initialValues={initialValues}
            formSettings={formSettings}
            groups={usersAndGroups.groups}
            users={usersAndGroups.users}
            isEdit={isEdit}
            handleSubmit={isEdit ? handleEdit : handleCreate}
            translations={translations}
            permissions={permissions}
            activeCustomerID={activeCustomerID}
            onEditGroupLicenses={onEditGroupLicenses}
            onLoadGroup={getGroup}
            group={group}
            activeCustomerGroupLicensingSetting={activeCustomerGroupLicensingSetting}
        />}
    </>
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        activeCustomerGroupLicensingSetting: state?.core?.login?.activeCustomer?.GroupLicensingSetting ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
};
const mapDispatchToProps = dispatch => {
    return {
        fetchGroups: data => dispatch(groupActions.fetchGroups(data)),
        fetchUsers: params => dispatch(userActions.fetchUsers(params)),
        fetchGroup: id => dispatch(groupActions.fetchGroup(id)),
        createGroup: data => dispatch(groupActions.createGroup(data)),
        editGroup: data => dispatch(groupActions.editGroup(data)),
        onEditGroupLicenses: data => dispatch(groupActions.editGroupLicenses(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(GroupDetails));